export const caseStudyBannerEn = {
  mainHeading: "Success Stories That Inspire",
  content:
    "Explore how we've helped businesses innovate, grow, & succeed through tailored tech solutions.",
  buttonText: "Let's Connect",
  backgroundImage: "/images/portfolio-banner-bg-image.png",
};

export const caseStudiesContentEn = {
  buttonText: "Read the Full Success Story",
  indusTryHeading: "Industry",
  caseStudiesHeading: "SUCCESS STORIES",
  loadMoreButton: "Load More",
  loadLessButton: "Load Less",
  readmoreButton: "Read more",
  caseStudyStats: [
    {
      icon: "progress-icon.svg",
      title: "100%",
      description: "Compliance with GDPR regulations"
    },
    {
      icon: "faster-growing.svg",
      title: "75%",
      description: "Faster forms processing"
    }
  ],
  cardsData: [
    {
      id: 7,
      title: "Shaping the Future of Logistics Industry Through Digital Innovation",
      industry: "Logistics",
      description:
        "Airdropja, a leading cross-border logistics platform, was developed by Bitsclan from the ground up. Our end-to-end automated solutions enabled package consolidation, transparent pricing, & real-time coordination, reducing costs & significantly improving operational efficiency.",
      image: "main-banner.png",
      pdfUrl: "Ticketing & Events Promotion Platform.pdf",
      tags: [
        // "Event ticketing system",
        // "Marketing automation",
        // "Customer support optimization",
        // "Admin panel usability",
        // "Scalable event promotion",
        // "Conversion rate improvement",
      ],
    },
    {
      id: 1,
      title: "AI-Powered Self-Study Learning App",
      industry: "Education Technology, AI Solutions",
      description:
        "The AI-powered self-study learning app developed by Bitsclan IT Solutions offers a flexible, engaging, & personalized learning experience. By combining AI-driven insights, gamification, & diverse content formats, the app empowers users to learn independently, stay motivated, & master subjects in a self-directed environment. This solution not only improves student outcomes but also makes learning accessible & enjoyable for a global audience.",
      image: "ai-self-study.avif",
      pdfUrl: "AI Case Studies 7.pdf",
      tags: [
        "AI-powered learning",
        "Personalized education",
        "EdTech solutions",
        "Gamification in learning",
        "Self-study app",
        "Scalable learning platform",
      ],
    },
    {
      id: 2,
      title: "Personalized AI Tech Newsletter Using RSS, OpenAI, & Gmail",
      industry: "AI Automation, Email Marketing, Technology",
      description:
        "The Personalized AI Tech Newsletter developed by Bitsclan IT Solutions is an ideal solution for professionals who want to stay informed without the stress of sifting through hundreds of articles daily. By automating the entire process, from content fetching to summarization & email delivery, we ve created a powerful, time saving tool for tech enthusiasts. This AI-powered workflow demonstrates how automation can drive efficiency, enhance user experience, & optimize information delivery in the modern tech landscape.",
      image: "personalized-ai.avif",
      pdfUrl: "AI Case Studies 05.pdf",
      tags: [
        "AI-powered news",
        "Tech news automation",
        "Personalized newsletters",
        "RSS integration",
        "Email automation",
        "Information overload solutions",
      ],
    },
    {
      id: 3,
      title: "Chat with Local LLMs using n8n & Ollama",
      industry: "AI Solutions, Workflow Automation, Data Privacy",
      description:
        "The n8n & Ollama integration by Bitsclan IT Solutions provided businesses with a secure, scalable, & cost-efficient solution for AIpowered interactions. By leveraging local models, the system ensures robust data privacy, flexibility, & cost savings, making it an ideal choice for businesses looking to adopt AI agents & workflows without compromising on security.",
      image: "chat-with-local.avif",
      pdfUrl: "AI Case Studies 02.pdf",
      tags: [
        "Local AI models",
        "Data privacy",
        "AI workflow automation",
        "Cost-effective AI solutions",
        "Secure AI interactions",
        "LLM integration",
      ],
    },
    {
      id: 4,
      title: "Cross-Border Shipping Platform Optimization",
      industry: "Logistics & Shipping",
      description:
        "With Bitsclan IT Solutions, Airdropja has transformed into a robust platform offering flexible shipping, efficient coordination, & reliable tracking. These improvements have solidified its position as a leader in Caribbean cross border shipping.",
      image: "cross-border-shipping.avif",
      pdfUrl: "Cross Border Shipping Platform.pdf",
      tags: [
        "Cross-border shipping",
        "Platform optimization",
        "Payment gateway integration",
        "Shipping flexibility",
        "Bug resolution",
        "User engagement",
      ],
    },
    {
      id: 5,
      title: "Electrical Testing & Calibration Services Web App",
      industry: "Electrical Testing & Calibration Platform",
      description:
        "With Bitsclan IT Solutions expertise, the platform evolved into a high-performing, fully integrated, & conversion-focused website. By addressing performance, responsiveness, & user journey gaps, the business can now confidently scale operations, improve customer satisfaction, & increase revenue in a competitive digital environment.",
      image: "electrical-testing.avif",
      pdfUrl: "Electrical Testing & Calibration Platform.pdf",
      tags: [
        "Website optimization",
        "Conversion rate optimization",
        "Mobile responsiveness",
        "Integrations",
        "Performance improvement",
        "Customer experience enhancement",
      ],
    },
    {
      id: 6,
      title: "Optimizing Ticketing & Event Promotion for Scalable Growth",
      industry: "Event Ticketing & Promotion",
      description:
        "With Bitsclan IT Solutions as its digital partner, the platform now operates as a high-performance, usercentric system, blending event management, ticketing, & promotion seamlessly. Through advanced marketing automation, robust support systems, & frictionless event creation workflows, the platform is poised to scale confidently, enabling event organizers to focus on creating unforgettable experiences.",
      image: "optimizing-ticketing.avif",
      pdfUrl: "Ticketing & Events Promotion Platform.pdf",
      tags: [
        "Event ticketing system",
        "Marketing automation",
        "Customer support optimization",
        "Admin panel usability",
        "Scalable event promotion",
        "Conversion rate improvement",
      ],
    },
    {
      id: 7,
      title: "Crafting Fresh Beverages, Redefining the Way You Sip",
      industry: "Food & Beverages (F&B)",
      description:
        "Fizz District is revolutionizing the beverage industry with fresh, handcrafted drinks made from real ingredients. Developed by Bitsclan, this innovative platform offers a seamless mobile & web experience, allowing customers to explore a variety of drinks & snacks, with real-time inventory tracking & flexible delivery or pickup options.",
      image: "optimizing-ticketing.avif",
      pdfUrl: "Ticketing & Events Promotion Platform.pdf",
      tags: [
        "Event ticketing system",
        "Marketing automation",
        "Customer support optimization",
        "Admin panel usability",
        "Scalable event promotion",
        "Conversion rate improvement",
      ],
    },
  ],
};

// {
//   id: 6,
//   title: "Healthcare Website Development",
//   industry: "Healthcare",
//   description:
//     "The platform is an online marketplace & auction designed for the dental industry, enabling the buying & selling of dental practices, equipment, & related assets. It focuses on transparency, security, & trust, ensuring legitimate transactions between verified professionals in the high-value dental sector. The goal was to create a secure, scalable platform that facilitates smooth & credible transactions in the dental marketplace.",
//   image: "health-care.png",
//   pdfUrl: "AI Case Studies 02.pdf",
//   tags: ["One", "Two", "Three", "Four"],
// },
// {
//   id: 7,
//   title: "HVAC Services Website Development",
//   industry: "HVAC Services",
//   description:
//     "The platform was developed as a comprehensive digital presence for an HVAC service provider specializing in installation, maintenance, & repair for both residential & commercial clients. The website focuses on building local trust, emphasizing 24/7 emergency response, & generating service leads through a customer-focused design that prioritizes user experience.",
//   image: "ac-services.png",
//   pdfUrl: "AI Case Studies 02.pdf",
//   tags: ["One", "Two", "Three", "Four"],
// },
// {
//   id: 8,
//   title: "Multilingual Solutions Platform Development",
//   industry: "Multilingual Solutions",
//   description: `The platform was developed to serve as a professional corporate storefront for a global provider of interpretation & translation solutions. The platform offers a wide range of services, from on-site & remote interpretation to document translation, transcription, & localization. The primary goal was to establish the company's authority, build client trust, & drive lead generation through a prominent "Book a Demo" call-to-action. The platform targets businesses & organizations worldwide in need of professional language services.`,
//   image: "multilangual-solution.png",
//   pdfUrl: "AI Case Studies 02.pdf",
//   tags: ["One", "Two", "Three", "Four"],
// },
// {
//   id: 9,
//   title: "Corporate Website Development for FMCG Wholesale",
//   industry: "FMCG Wholesale",
//   description:
//     "The website was developed as a corporate platform for an international wholesale distributor of confectionery & soft drink brands. Serving a B2B audience, including manufacturers, wholesale buyers, & large retail groups across the UK & Europe, the platform's main goal was to showcase the company’s expertise, buying power, & wide product range. The site also provides essential contact information for business inquiries, enhancing accessibility for potential clients.",
//   image: "fmgc.png",
//   pdfUrl: "AI Case Studies 02.pdf",
//   tags: ["One", "Two", "Three", "Four"],
// },
// {
//   id: 10,
//   title: "Website Development for a Trading & Logistics Company",
//   industry: "Trading & Logistics",
//   description:
//     "The website serves as a professional digital storefront & informational hub for a global trading & logistics company. It showcases the company’s expertise in sourcing & supplying top branded consumer goods worldwide, while highlighting its comprehensive logistics services. The site aims to build trust & attract new suppliers & customers by emphasizing the company’s global reach, core competencies, & prestigious brands.",
//   image: "trading-logistics.avif",
//   tags: ["One", "Two", "Three", "Four"],
// },
// {
//   id: 11,
//   title: "Real Estate Construction Website",
//   industry: "Construction & Architecture",
//   description:
//     "The website was developed as a portfolio for a company specializing in modern construction & architecture. The primary goal was to showcase the firm’s craftsmanship through a gallery of high-quality images of completed residential projects. The minimalist design focuses on high-resolution photography of modern homes, interiors, & unique architectural features, targeting potential clients seeking custom residential construction.",
//   image: "Construction.avif",
//   caseStudyPdf: "architecture.pdf",
//   pdfUrl: "AI Case Studies 02.pdf",
//   tags: ["One", "Two", "Three", "Four"],
// },
// {
//   id: 12,
//   title: "Hair Salon Website Development",
//   industry: "Wellness & Aesthetics Services",
//   description: `The website was developed to showcase the salon's high-end aesthetic & expertise in hair styling & extensions. The platform includes a Lookbook to display the salon's work & offers a seamless online booking experience. The website embodies the salon’s philosophy of "perfection in every detail," attracting discerning clients seeking premium beauty services.`,
//   image: "wellness-and-asthatics.png",
//   pdfUrl: "AI Case Studies 02.pdf",
//   tags: ["One", "Two", "Three", "Four"],
// },
// {
//   id: 13,
//   title: "E-Commerce Website Development for Baby Accessories",
//   industry: "E-commerce",
//   description:
//     "The website is an e-commerce platform specializing in baby accessories, particularly baby monitors. The site offers a range of essential products designed to provide parents with a trustworthy shopping experience. With a modern, clean aesthetic & a soft color palette, the platform creates a welcoming space for parents, focusing on baby safety.",
//   image: "baby-accessories.png",
//   pdfUrl: "AI Case Studies 02.pdf",
//   tags: ["One", "Two", "Three", "Four"],
// },
// {
//   id: 14,
//   title: "Athletic Therapy Website Development",
//   industry: "Rehabilitative Healthcare",
//   description:
//     "The website was developed for a solo practitioner or small clinic specializing in athletic therapy & injury rehabilitation. The main goal was to inform potential clients about the services offered, build trust, & provide an easy way to book appointments. The website features a clean, minimalist design focused on professionalism & user ease.",
//   image: "rehabilitative-healthcare.avif",
//   pdfUrl: "AI Case Studies 02.pdf",
//   tags: ["One", "Two", "Three", "Four"],
// },
// {
//   id: 15,
//   title: "Town Title Agency Website Development",
//   industry: "Real Estate",
//   description:
//     "The website serves as a digital corporate brochure aimed at establishing the company’s authority & credibility in the title industry. Focused on transparency, the site highlights the company's history, mission, & industry affiliations, targeting real estate agents, lenders, & consumers who need title & settlement services. The site is designed to provide detailed, clear content to build trust.",
//   image: "town-title.png",
//   pdfUrl: "AI Case Studies 02.pdf",
//   tags: ["One", "Two", "Three", "Four"],
// },
// {
//   id: 16,
//   title: "Digital Marketing Agency Website Development",
//   industry: "Digital Marketing Agency",
//   description:
//     "The website was developed for a digital marketing agency specializing in elevating brands on platforms like TikTok. The agency offers services such as marketing, advertising, & content creation. The website features a modern design with a dark color scheme & vibrant blue accents, conveying innovation & forward-thinking, which aligns with the agency's image.",
//   image: "social-media.png",
//   pdfUrl: "AI Case Studies 02.pdf",
//   tags: ["One", "Two", "Three", "Four"],
// },
// {
//   id: 17,
//   title: "Medical Device Technology Website Development",
//   industry: "Healthcare",
//   description:
//     "This website was designed to serve as an informational hub, offering detailed scientific content about the company’s patented medical devices. The primary audience includes medical professionals, researchers, & investors. The website prioritizes technical & scientific credibility over modern aesthetics, providing essential details about the company’s research, technology, & medical advancements.",
//   image: "medical-device-technology.png",
//   pdfUrl: "AI Case Studies 02.pdf",
//   tags: ["One", "Two", "Three", "Four"],
// },
// {
//   id: 18,
//   title: "AI-Powered Learning Platform Website Development",
//   industry: "Education",
//   description:
//     "This website was created for an AI-powered learning platform designed to enhance lectures & learning materials. The main goal was to educate potential users—students, educators, & institutions—about the platform's core features & benefits. The website’s design is modern, clean, & intuitive, with a minimalist color scheme & bright blue accents for key elements & calls to action.",
//   image: "education.png",
//   pdfUrl: "AI Case Studies 02.pdf",
//   tags: ["One", "Two", "Three", "Four"],
// },
// {
//   id: 19,
//   title: "Physical Therapy & Sports Medicine Website Development",
//   industry: "Physical Therapy & Sports Medicine",
//   description:
//     "This website serves as a digital front door for a physical therapy clinic, providing essential information to both potential & existing patients. The platform showcases the clinic’s services, streamlines appointment scheduling, & communicates the clinic’s approach to care. The primary goal was to make it easy for visitors to access information & take action.",
//   pdfUrl: "AI Case Studies 02.pdf",
//   tags: ["One", "Two", "Three", "Four"],
// },
// {
//   id: 20,
//   title: "Ticketing & Event Promotion Platform Development",
//   industry: "Event Ticketing & Promotion",
//   description:
//     "The platform was designed to empower event organizers, creators, & entrepreneurs by simplifying ticket sales & boosting event visibility through a robust marketing infrastructure. It supports everything from concerts & conferences to community events, streamlining the planning process & enhancing user experience.",
//   pdfUrl: "AI Case Studies 02.pdf",
//   tags: ["One", "Two", "Three", "Four"],
// },
// {
//   id: 21,
//   title: "Cross-Border Shipping Platform Development",
//   industry: "Logistics & Shipping",
//   description:
//     "Airdropja is a revolutionary cross-border shipping platform designed to simplify the international shipping experience for individuals in Jamaica. Focused on transparency, coordination, & affordability, Airdropja allows users to consolidate multiple packages into a single shipment, while facilitating direct communication between customers shipping from the same origin point.",
//   pdfUrl: "AI Case Studies 02.pdf",
//   tags: ["One", "Two", "Three", "Four"],
// },